import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService";
import { initialAuthState } from "../../services/ApiService";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import "./staffLogin.css";

const Login = ({ handleLoginFlag }) => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [designations, setDesignations] = useState([]);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const payload = {
        staffId: userId,
        password,
        designation: role,
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
      };

      const response = await ApiService.post("/login/LoginDetails", payload, {
        withCredentials: true,
      });

      const rrr = response.data.data;

      if (rrr.status === "ACTIVE") {
        localStorage.setItem("userId", userId);
        localStorage.setItem("role", rrr.designation);
        localStorage.setItem("userProfile", JSON.stringify(response.data));

        const isSubDealer = role === "Sub Dealer";

        if (isSubDealer) {
          const subDealerData = response.data.data?.data?.[0];

          if (subDealerData) {
            localStorage.setItem("userId", subDealerData.subDealerId);
            localStorage.setItem("companyCode", subDealerData.companyCode);
            localStorage.setItem("unitCode", subDealerData.unitCode);
            localStorage.setItem("id", subDealerData.id);
            localStorage.setItem("branchName", subDealerData.branchName || "");
          }
        } else {
          const staffData = response.data.data;
          const permission = Array.isArray(staffData.permissions)
            ? staffData.permissions.length
            : 0;

          localStorage.setItem("companyCode", staffData.companyCode);
          localStorage.setItem("unitCode", staffData.unitCode);
          localStorage.setItem("id", staffData.id);
          localStorage.setItem("branchName", staffData.branch?.branchName || "");
          localStorage.setItem("branch_id", staffData.branch?.id || "");
          localStorage.setItem(
            "userPermissions",
            JSON.stringify(staffData?.permissions[permission - 1]?.permissions) ||
            ""
          );
        }

        handleLoginFlag();
      } else {
        setError("Please enter correct login details.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err?.response?.data?.internalMessage ||
        "Failed to login. Please check your credentials."
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchDesignations = async () => {
    try {
      const response = await ApiService.post("/designations/getAllDesignation");
      const fetchedData = Array.isArray(response.data) ? response.data : [];

      setDesignations([
        ...fetchedData,
        { designation: "CEO" },
        { designation: "Sub Dealer" },
        { designation: "Sub Dealer Staff" },
      ]);
    } catch (error) {
      console.error("Error fetching designations:", error);
      setDesignations([]);
    }
  };

  useEffect(() => {
    fetchDesignations();
  }, []);

return (
  <div className="staff-login-page staff-login-alt-page">
    <div className="staff-login-alt-layout">
      <section className="staff-login-alt-info">
        <div className="staff-login-alt-logo-card">
          <img src="/logo.png" className="staff-login-alt-logo" alt="Logo" />
        </div>

        <h1 className="staff-login-alt-heading">
          Staff Operations Portal
        </h1>
{/* 
        <p className="staff-login-alt-description">
          Login to manage orders, services, branches, inventory and customer operations.
        </p>

        <div className="staff-login-alt-points">
          <span>Secure Access</span>
          <span>Role Based Dashboard</span>
          <span>Way4Track Internal System</span>
        </div> */}
      </section>

      <section className="staff-login-alt-card">
        <div className="staff-login-alt-card-head">
          <p className="staff-login-alt-eyebrow">Welcome back</p>
          <h2>Login to your account</h2>
          <span>Use your staff ID and assigned role.</span>
        </div>

        {error && <div className="staff-login-alt-error">{error}</div>}

        <form className="staff-login-alt-form" onSubmit={handleLogin}>
          <div className="staff-login-alt-field">
            <label>Registered ID</label>
            <input
              type="text"
              id="userId"
              placeholder="Enter registered ID"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            />
          </div>

          <div className="staff-login-alt-field">
            <label>Password</label>
            <div className="staff-login-alt-password">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <div className="staff-login-alt-field">
            <label>Role</label>
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value="">Select Role</option>
              {designations.map((item, index) => (
                <option key={index} value={item.designation}>
                  {item.designation}
                </option>
              ))}
            </select>
          </div>

          <button
            type="submit"
            className="staff-login-alt-submit"
            disabled={loading}
          >
            {loading ? "Checking credentials..." : "Login Securely"}
          </button>
        </form>
      </section>
    </div>
  </div>
);
};

export default Login;








// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import ApiService from '../../services/ApiService';
// import { initialAuthState } from '../../services/ApiService';
// import { FaEye, FaEyeSlash } from 'react-icons/fa6';

// const Login = ({ handleLoginFlag }) => {
//   const [userId, setUserId] = useState('');
//   const [password, setPassword] = useState('');
//   const [role, setRole] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [designations, setDesignations] = useState([]);

//   const navigate = useNavigate();
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const payload = {
//         staffId: userId,
//         password: password,
//         designation: role,
//         companyCode: initialAuthState.companyCode,
//         unitCode: initialAuthState.unitCode,
//       };

//       const response = await ApiService.post('/login/LoginDetails', payload, { withCredentials: true });
//       console.log("Login response:", response.data.data.status);
//       const rrr = response.data.data
//       if (rrr.status === 'ACTIVE') {
//         localStorage.setItem('userId', userId);
//         localStorage.setItem('role', rrr.designation);
//         // localStorage.setItem('password', password);
//         localStorage.setItem('userProfile', JSON.stringify(response.data));

//         // if (rrr.designation === 'CEO') {
//         //   const accessToken = rrr.accessToken;

//         //   if (accessToken) {
//         //     sessionStorage.setItem('accessToken', accessToken);
//         //   }
//         // }

//         const isSubDealer = role === 'Sub Dealer';
//         if (isSubDealer) {
//           const subDealerData = response.data.data?.data?.[0];
//           if (subDealerData) {
//             localStorage.setItem('userId', subDealerData.subDealerId);
//             localStorage.setItem('companyCode', subDealerData.companyCode);
//             localStorage.setItem('unitCode', subDealerData.unitCode);
//             localStorage.setItem('id', subDealerData.id);
//             localStorage.setItem('branchName', subDealerData.branchName || '');
//           }
//         } else {
//           const staffData = response.data.data;

//           const permission = Array.isArray(staffData.permissions) ? staffData.permissions.length : 0;

//           localStorage.setItem('companyCode', staffData.companyCode);
//           localStorage.setItem('unitCode', staffData.unitCode);
//           localStorage.setItem('id', staffData.id);
//           localStorage.setItem('branchName', staffData.branch?.branchName || '');
//           localStorage.setItem('branch_id', staffData.branch?.id || '');
//           localStorage.setItem('userPermissions', JSON.stringify(staffData?.permissions[permission - 1]?.permissions) || '');
//         }

//         // await fetchUserPermissions(
//         //   localStorage.getItem('userId'),
//         //   localStorage.getItem('companyCode'),
//         //   localStorage.getItem('unitCode')
//         // );

//         handleLoginFlag(); // redirect / update UI
//       } else {
//         alert("Please enter correct login details");
//         setError(response?.internalMessage || 'Invalid login credentials.');
//       }
//     } catch (err) {
//       console.error("Login error:", err);
//       setError(
//         err?.response?.data?.internalMessage ||
//         'Failed to login. Please check your credentials.'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchUserPermissions = async (userId, companyCode, unitCode) => {
//     try {
//       const payload = { userId, companyCode, unitCode };
//       const response = await ApiService.post(
//         '/permissions/getPermissionDetails',
//         payload
//       );

//       if (response && response.status) {
//         const permissions = response.data.permissions; // Assuming API returns an object of permissions
//         localStorage.setItem('userPermissions', JSON.stringify(permissions));
//         console.log('Permissions fetched successfully:', permissions);
//       } else {
//         console.error('Failed to fetch permissions:', response);
//       }
//     } catch (err) {
//       console.error('Error fetching permissions:', err);
//     }
//   };


//   const fetchDesignations = async () => {
//     try {
//       const response = await ApiService.post("/designations/getAllDesignation");
//       const fetchedData = Array.isArray(response.data) ? response.data : [];

//       // Add custom roles
//       const updatedDesignations = [
//         ...fetchedData,
//         { designation: "CEO" },
//         { designation: "sub dealer" },
//         { designation: "sub dealer staff" },
//       ];

//       setDesignations(updatedDesignations);
//     } catch (error) {
//       console.error("Error fetching designations:", error);
//       setDesignations([]);
//     }
//   };

//   useEffect(() => {
//     fetchDesignations();
//   }, []);


//   return (
//     <div className="flex items-center justify-center h-screen">
//       <div className="p-8 rounded-lg w-96 space-y-12 bg-white shadow-md">
//         {/* Form */}
//         <img src="logo.png" className="mx-auto" alt="Logo" />
//         <form className="space-y-8" onSubmit={handleLogin}>
//           {/* User ID Input */}
//           <div className="mb-4">
//             <label
//               htmlFor="userId"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Registered ID
//             </label>
//             <input
//               type="text"
//               id="userId"
//               placeholder="Enter your ID"
//               value={userId}
//               onChange={(e) => setUserId(e.target.value)}
//               className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none"
//               required
//             />
//           </div>

//           {/* Password Input */}
//           <div className="mb-4">
//             <label
//               htmlFor="password"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Password
//             </label>
//             <div className="relative w-full">
//               <input
//                 type={showPassword ? 'text' : 'password'}
//                 id="password"
//                 placeholder="Enter your Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none"
//                 required
//               />
//               <span
//                 className="absolute inset-y-0 right-3 flex items-center text-gray-500 cursor-pointer"
//                 onClick={() => setShowPassword(!showPassword)}
//               >
//                 {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
//               </span>
//             </div>
//           </div>

//           <div className="mb-6">
//             <label htmlFor="role" className="block text-sm font-medium text-gray-700">
//               Role
//             </label>
//             <select
//               id="role"
//               value={role}
//               onChange={(e) => setRole(e.target.value)}
//               className="w-full p-3 border rounded-md bg-gray-200 focus:outline-none"
//             >
//               <option value="">Select Role</option>
//               {designations.map((item, index) => (
//                 <option key={index} value={item.designation}>
//                   {item.designation}
//                 </option>
//               ))}
//             </select>
//           </div>


//           {/* Login Button */}
//           <button
//             type="submit"
//             className="w-full bg-green-700 text-white py-2 rounded-md transition duration-200 disabled:bg-green-400"
//             disabled={loading}
//           >
//             {loading ? 'Logging in...' : 'Log In'}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;
